import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../authentication/data-access/services/auth.service'; // replace with your actual path
import { Router } from '@angular/router';
import { Roles, UserAttributes } from '../../../authentication/data-access/models/auth.model';
import { UserStore } from '../../data-access/stores/user.store';
import { combineLatest } from "rxjs";
import { map, take } from "rxjs/operators";

@Component({
    selector: 'app-layout-resolver',
    templateUrl: './navbar-layout-resolver.component.html',
    standalone: false
})
export class NavbarLayoutResolverComponent implements OnInit {
  userRole!: Roles;
  rolesEnum = Roles;
  userDetails!: UserAttributes;
  navbarState$ = combineLatest([
    this.authService.isLoggedIn$,
    this.userStore.get()
  ]).pipe(map(([loggedIn, user]) => ({
      loggedIn: !!loggedIn,
      isOverviewer: user?.roles?.includes(Roles.OVERVIEWER) ?? false
    }))
  );
  url: string = '';

  constructor(
    private authService: AuthService,
    private userStore: UserStore,
    private router: Router
  ) {}

  ngOnInit() {
    this.url = this.router.url;
    this.userStore.get().subscribe((user) => {
      this.userDetails = user;
    });
    this.authService.resolveAuthState().pipe(take(1)).subscribe();
  }

  login(): void {
    this.authService.login();
  }

  logout(): void {
    this.authService.logout();
  }
}
